<template>
  <v-row>
    <v-col cols="12" class="pa-3 pr-7" v-if="!loading">
      <showConvocationForm v-if="entrepreneurship.version=='v1'" :data="entrepreneurship" />
      <showConvocationFormV2 v-if="entrepreneurship.version=='v2'" :data="entrepreneurship" />
      <showConvocationFormV3 v-if="entrepreneurship.version=='v3'" :data="entrepreneurship" />
    </v-col>
    
    <v-col cols="12" class="pt-2">
      <v-sheet
        width="100%"
        outlined 
      >
        <v-row>
          <v-col cols="12" class="ma-8">
            <label class="font-weight-regular text-uppercase">
              Equipo emprendedor:
            </label>
          </v-col>
          <v-col cols="12">
            <showProfilesComponent :data="entrepreneurship.entrepreneurial_profile" />
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2" v-if="entrepreneurship.condition=='pending'">
      <v-sheet
        width="100%"
        outlined 
      >
        <v-row class="pa-8">
          <v-col cols="12">
            <label class="font-weight-regular text-uppercase">
              Opciones
            </label>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              block
              class="mr-2 mt-2"
              depressed
              color="primary"
              @click="inProgressEntrepreneurship()">
              Marcar como en progreso
            </v-btn>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              block
              class="mr-2 mt-2"
              depressed
              color="primary"
              :disabled="entrepreneurship.type_postulations_id!=3"
              @click="recategorizeEntrepreneurship()">
              Recategorizar
            </v-btn>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              block
              class="mt-2 mr-2"
              depressed
              color="primary"
              @click="rejectedEntrepreneurship()">
              Rechazar Proyecto
            </v-btn>
          </v-col>
          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              block
              class="mt-2"
              depressed
              color="primary"
              @click="confirmEntrepreneurship()">
              Aceptar Proyecto
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="d-sm-flex pt-8 pb-8">
      <v-btn 
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-auto mt-2"
        depressed
        color="primary"
        :to="{ name: 'entrepreneurshipsEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        v-if="entrepreneurship.condition=='in_progress'"
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        depressed
        color="primary"
        @click="inPendingEntrepreneurship()">
        Marcar como pendiente
        <v-icon
          dark
        >
          mdi-arrow-right
        </v-icon>
      </v-btn>

      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        depressed
        color="primary"
        :loading="loading_download"
        @click="downloadPDF" >
        <v-icon
          dark
        >
          mdi-download
        </v-icon>
        Descargar PDF
      </v-btn>
    </v-col>

    <v-dialog
      v-model="dialog_confirm"
      max-width="420">
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>

        <v-card-text>
          {{ message_confirm }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="info darken-1"
            text
            :disabled="loading_btn"
            @click="dialog_confirm = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="info darken-1"
            text
            :loading="loading_btn"
            @click="changeConditionEntrepreneurship"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_recategorize"
      max-width="420">
      <v-card>
        <v-card-title class="text-h5">
          Recategorizar emprendimiento
        </v-card-title>

        <v-card-text>
          Seleccione la categoria a la cual quiere mover:
          <v-select
            class="pt-8"
            :items="type_postulations"
            v-model="type_postulations_id"
            item-text="name"
            item-value="id"
            label="Tipo de postulación*"
            outlined
          ></v-select>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="info darken-1"
            text
            :disabled="loading_btn"
            @click="dialog_recategorize = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="info darken-1"
            text
            :loading="loading_btn"
            @click="changeCategoryEntrepreneurship"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  import download from 'downloadjs'
  const VUE_URL_API = process.env.VUE_APP_URL_API

  import showConvocationForm from '@/components/entrepreneur/convocation/showConvocationForm.vue'
  import showConvocationFormV2 from '@/components/convocation_form/showConvocationFormV2.vue'
  import showConvocationFormV3 from '@/components/convocation_form/showConvocationFormV3.vue'
  import showProfilesComponent from '@/components/team/showProfilesComponent.vue'

  export default {
    name: 'showEntrepreneurshipsEdition',
    components: {
      showConvocationForm,
      showConvocationFormV2,
      showConvocationFormV3,
      showProfilesComponent
    },
    data: () => ({
      dialog_confirm:false,
      dialog_recategorize:false,
      message_confirm:null,
      condition:null,

      loading_download:false,
      loading:true,
      loading_btn:false,
      edition_id:null,
      convocation_form_id:null,
      url:null,

      entrepreneurship:[],

      type_postulations_id:null,
      type_postulations:[],

      attrs: {
        boilerplate: false,
      },
    }),

    methods:{
      async getEntrepreneurship(){
        await axios.get('admin/edition/'+this.edition_id+'/convocation-form/'+this.convocation_form_id).then(response =>{
          this.entrepreneurship = response.data.entrepreneurship

          //this.url = APP_URL + '/generate-pdf/' + this.convocation_form_id
          
          this.loading=false
        }).catch(error => {
          console.log(error)
        })
      },

      async getTypePostulations(){
        try {
          await axios.get('type-postulations').then(response =>{
            this.type_postulations = response.data.data.type_postulations
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      confirmEntrepreneurship(){
        this.condition = 'accepted'
        this.message_confirm = '¿Estas seguro de querer aceptar este emprendimiento?'
        this.dialog_confirm = true
      },

      rejectedEntrepreneurship(){
        this.condition = 'rejected'
        this.message_confirm = '¿Estas seguro de querer rechazar este emprendimiento?'
        this.dialog_confirm = true
      },

      recategorizeEntrepreneurship(){
        this.type_postulations_id = this.entrepreneurship.type_postulations_id
        this.getTypePostulations().then(
          this.dialog_recategorize = true
        )
      },

      async changeCategoryEntrepreneurship(){
        this.loading_btn=true
        await axios.put('admin/edition/'+this.edition_id+'/convocation-form/'+this.convocation_form_id+'/recategorize',{
          type_postulations_id: this.type_postulations_id
        }).then(() =>{
          this.dialog_recategorize = false
          this.loading_btn = false
          this.loading = true
          this.getEntrepreneurship()
        })
      },

      inProgressEntrepreneurship(){
        this.condition = 'in_progress'
        this.message_confirm = '¿Estas seguro de querer marcar como en progreso a este emprendimiento?'
        this.dialog_confirm = true
      },

      inPendingEntrepreneurship(){
        this.condition = 'pending'
        this.message_confirm = '¿Estas seguro de querer marcar como pendiente a este emprendimiento?'
        this.dialog_confirm = true
      },

      async changeConditionEntrepreneurship(){
        this.loading_btn = true
        await axios.put('admin/edition/'+this.edition_id+'/convocation-form/'+this.convocation_form_id,{
            condition: this.condition
          }).then(() =>{
            this.loading_btn = false
            this.$router.push({ name: 'entrepreneurshipsEdition' })
          })
      },

      async downloadPDF(){
        this.loading_download=true
        this.url = VUE_URL_API + '/admin/edition/'+this.edition_id+'/convocation-form/'+this.convocation_form_id+'/generate-pdf'

        await axios.get(
          this.url, 
          {responseType: 'blob'}
        ).then((response) => {
          //window.open(URL.createObjectURL(response.data));
          const content = response.headers['content-type'];
          download(response.data, this.convocation_form_id+' - '+ this.entrepreneurship.title , content)
          this.loading_download=false
        })
      },

      async downloadPDF2() {

        await axios({
          url: this.url,
          method: 'GET',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          responseType: 'blob',
        }).then((res) => {
          var FILE = window.URL.createObjectURL(new Blob([res.data]));
        
          var docUrl = document.createElement('x');
          docUrl.href = FILE;
          docUrl.setAttribute('download', 'sample.pdf');
          document.body.appendChild(docUrl);
          docUrl.click();
        });
      },
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.convocation_form_id = this.$route.params.convocation_form_id;
      this.getEntrepreneurship()
      },
  }
</script>